import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  faqslist,
  deletefaqs,
  voucherlist,
  deletevoucher,
} from "../../service/Mainservice";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import Deletepopup from "./Aresure";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import ListControls from "../ListControls/ListControls";
import Pagination from "../Pagination/pagination";

const VoucherList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  // const [searchvalue, setsearchvalue] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [sortBy, sortOrder]);

  // useEffect(() => {
  //   getData();
  // }, [searchvalue]);

  const getData = async (page = 1) => {
    try {
      const response = await voucherlist({ page, pageSize: 10, sortBy, sortOrder });
      console.log(response);
      setData(response.data.data);
      setpagination(response.data.pagination || { page, limit: 10, total: 0 });

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
  };

  // const handlesearch = async (e) => {
  //   setsearchvalue(e.target.value);
  //   getData(1, e.target.value);
  // };

  const handledelete = async () => {
    try {
      const response = await deletevoucher(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };
  console.log(data);
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Vouchers</h1>
          <div className="data_headdown">
            <h1 className="data_add" onClick={() => navigate("/Add_Voucher")}>
              <AddIcon /> Add Voucher
            </h1>
          </div>
        </div>
        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"code",label:"Code"},{value:"discountValue",label:"Discount"},{value:"usageCount",label:"Usage"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Discount Type</th>
                    <th>Value</th>
                    <th>Max Discount</th>
                    <th>Min Order</th>
                    <th>Expiry Date</th>
                    <th>Usage Limit</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.code}</td>
                        <td>{item.discountType}</td>
                        <td>{item.discountValue}</td>
                        <td>{item.maxDiscount}</td>
                        <td>{item.minOrderValue}</td>
                        <td>{item.expiryDate}</td>
                        <td>{item.usageLimit}</td>
                        <td>
                          <div style={{ width: "70px" }}>
                            {" "}
                            <EditIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() =>
                                navigate("/Edit_Voucher", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <DeleteIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No Voucher Added Yet</p>
        )}

        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handledelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default VoucherList;
